import { render, staticRenderFns } from "./pointsList.vue?vue&type=template&id=6cb5398b&scoped=true&"
import script from "./pointsList.vue?vue&type=script&lang=js&"
export * from "./pointsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb5398b",
  null
  
)

export default component.exports